import { render, staticRenderFns } from "./CustomAdCell.vue?vue&type=template&id=f63f93d6&scoped=true&"
import script from "./CustomAdCell.vue?vue&type=script&lang=js&"
export * from "./CustomAdCell.vue?vue&type=script&lang=js&"
import style0 from "./CustomAdCell.vue?vue&type=style&index=0&id=f63f93d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f63f93d6",
  null
  
)

export default component.exports